exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tablausuarios thead th:nth-child(4){width:90px}.tablausuarios thead th:nth-child(3){width:150px}.tablausuarios thead th:nth-child(2){width:350px}", ""]);

// exports
